import type from './user-canceled-new-recording.type';
import createStandardAction from '../../utilities/create-standard-action';

const userCanceledNewRecording = createStandardAction(type);

export default userCanceledNewRecording;
